import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import {Modal} from "antd";

import '../../css/components/ImageList.css';
import '../../css/components/ExpandableImage.css';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        // width: 1000
    },
});

class ImageGridList extends Component {

    state = {visible: false, tile: null};

    showModal = (image) => {
        this.setState({
            visible: true,
            tile: image
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false
        });
    };


    render() {

        return (
            <div className={"img-grd-lst"}>
                {
                    this.state.tile && <Modal
                        visible={this.state.visible}
                        onCancel={this.handleCancel}
                        footer={null}>
                        <div className={"ovrly-wrap"}>
                            <img className={"exp-img-full"} src={this.state.tile.img} alt={this.state.tile.title}/>
                        </div>
                    </Modal>
                }
                <GridList cellHeight={200} cols={4}>
                    {this.props.images.map(tile => (
                        <GridListTile className={"a"} key={tile.img} cols={tile.cols || 1}>
                            <img src={tile.img}
                                 alt={tile.title}
                                 style={tile.alignTop && window.innerWidth > 600 ? {top: '90%'} : {}}
                                 onClick={() => this.showModal(tile)}/>
                        </GridListTile>
                    ))}
                </GridList>
            </div>
        );
    }
}

ImageGridList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImageGridList);